import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=e9b9ee40&scoped=true&"
import script from "./Owners.vue?vue&type=script&lang=js&"
export * from "./Owners.vue?vue&type=script&lang=js&"
import style0 from "./Owners.vue?vue&type=style&index=0&id=e9b9ee40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b9ee40",
  null
  
)

export default component.exports